<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-blue text-white">
        <span> لیست فاکتورهای</span>
        <q-chip square :label="agentName" icon="support_agent">
          <q-badge class="q-ml-sm" text-color="white" color="deep-orange-10" :label="`تعداد در هدف ${items.filter(item=> item.Target).length} از ${items.length}`"/>
        </q-chip>
        <template v-slot:action>
          <q-btn icon="close" flat round dense v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <LoadListSkeleton v-if="items.length===0"/>
      <LoadListSkeleton v-if="items.length===0"/>
      <LoadListSkeleton v-if="items.length===0"/>
      <LoadListSkeleton v-if="items.length===0"/>
      <LoadListSkeleton v-if="items.length===0"/>
      <AgentFactorListDesktop :items="items" v-if="items.length!==0 && !$q.screen.lt.md" />
      <AgentFactorListMobile :items="items" v-if="items.length!==0 && $q.screen.lt.md" />
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import LoadListSkeleton from "@/components/generals/LoadListSkeleton";
import AgentFactorListDesktop from "@/components/Agents/FactorList/AgentFactorListDesktop";
import AgentFactorListMobile from "@/components/Agents/FactorList/AgentFactorListMobile";

export default {
  name: "AgentsFactorsList",
  components: {AgentFactorListMobile, AgentFactorListDesktop, LoadListSkeleton},
  props:{
    userId:{
      type:Number,
      required: true
    },
    startDate:{
      type: String,
      required: true
    },
    endDate:{
      type: String,
      required: true
    },
    agentName:{
      type: String,
      required: true
    }
  },
  data(){
    return{
      items:[]
    }
  },
  methods:{
    ...mapActions({
      getFactorsList:'Agents/getFactorList'
    })
  },
  created() {
    this.getFactorsList({
      startDate: this.startDate.replaceAll('/','-'),
      endDate: this.endDate.replaceAll('/','-'),
      userId: this.userId
    }).then((res)=>{
      this.items = res
    })
  }
}
</script>

<style scoped>

</style>